// Follower Tracker feature entry — who followed, who unfollowed, every day.
import { UserCheck } from "lucide-react";
import type { FeatureModule } from "../registry";

const followers: FeatureModule = {
  id: "followers",
  nav: [{ to: "/followers", label: "Followers", icon: UserCheck, group: "insights", order: 20 }],
  routes: [
    {
      path: "/followers",
      lazy: async () => ({ Component: (await import("./FollowersPage")).FollowersPage }),
    },
  ],
};

export default followers;
